/**
 * Detecta teléfonos móviles (no tabletas ni escritorio).
 * iPad y Android tablet quedan excluidos para permitir acceso desde tableta.
 */
export function isPhoneDevice() {
    if (typeof navigator === 'undefined') {
        return false;
    }

    const ua = navigator.userAgent || '';

    const isIPad =
        /\biPad\b/i.test(ua) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1 && !/\biPhone\b|\biPod\b/i.test(ua));
    if (isIPad) {
        return false;
    }

    if (/\bTablet\b/i.test(ua) || /\bPlayBook\b/i.test(ua) || /\bSilk\b/i.test(ua)) {
        return false;
    }

    if (/Android/i.test(ua)) {
        return /Mobile/i.test(ua);
    }

    if (/\biPhone\b|\biPod\b/i.test(ua)) {
        return true;
    }

    if (/Windows Phone|IEMobile|Opera Mini|webOS/i.test(ua)) {
        return true;
    }

    if (/BlackBerry/i.test(ua) && !/\bTablet\b/i.test(ua)) {
        return true;
    }

    return false;
}
